// import { log } from "../../";
import * as React from "react";
import { computed } from "mobx";
import { observer, inject } from "mobx-react";

import { CategoryType } from "models";

import CategoryItemCardContainer, { renderLine, renderImage, calculateSizes } from "./CategoryItemCardContainer";
import {
    VocabularyCard,
    ExpressionCard,
    TextOnlyCard,
    ExpressionTextOnlyCard,
    LessonCard,
    ImageOnlyCard,
} from "./CategoryItemCardComponents";
import { CategoryItemCardProps } from "./CategoryItemCard";

// Layout
import { Row, Col } from "layout";

// Utils

import CategoryImage from "models/customLists/CategoryImage";
import { ActivityCategoryItem } from "models/customLists/CategoryItem";

@inject("rootStore")
@observer
export default class PreviewCategoryItemCard extends React.Component<CategoryItemCardProps> {
    @computed
    get imageURL(): string {
        if (this.props.item !== undefined) {
            return this.props.item.imageURL;
        }
    }

    @computed
    get sizes(): any {
        return calculateSizes(this.props.cardHeight, this.props.cardWidth, this.props.fontSize);
    }

    render() {
        if (!this.props.rootStore) {
            return null;
        }

        let { lessonSelection, showWrongAnswers, rootStore, ...other } = this.props;
        return (
            <CategoryItemCardContainer {...other}>
                {this.props.children}
                {this.renderChildren()}
            </CategoryItemCardContainer>
        );
    }

    renderChildren() {
        return (
            <Col xs={12}>
                <Row center="xs">{this.cardContentForItem(this.props.item)}</Row>
            </Col>
        );
    }

    private cardContentForItem(categoryItem: ActivityCategoryItem | CategoryImage) {
        let { audioStore, activityStore } = this.props.rootStore;

        let longestItem = this.props.category.longestItem;

        if (categoryItem instanceof ActivityCategoryItem) {
            let type = categoryItem.typeForLessonSelection(this.props.lessonSelection);
            let cardProps = {
                audioStore: audioStore,
                categoryItem: categoryItem,
                longestItem: longestItem,
                height: this.sizes.height,
            };
            let { useDoubleSidedCards, hideAnswers } = activityStore.activityOptions.flashcardsOptions;
            switch (type) {
                case CategoryType.Vocabulary:
                    if (useDoubleSidedCards || hideAnswers) {
                        return <ImageOnlyCard {...cardProps} />;
                    } else {
                        return <VocabularyCard {...cardProps} />;
                    }

                case CategoryType.VocabularyTextOnly:
                    return <TextOnlyCard {...cardProps} />;

                case CategoryType.Expression:
                    return <ExpressionCard {...cardProps} />;

                case CategoryType.ExpressionTextOnly:
                    return <ExpressionTextOnlyCard {...cardProps} />;

                case CategoryType.Lesson:
                    return <LessonCard {...cardProps} />;

                default:
                    return null;
            }
        } else if (categoryItem instanceof CategoryImage) {
            return (
                <Col xs={true}>
                    {this.imageURL && renderImage(this.imageURL, this.sizes.height * 0.8)}
                    {renderLine(categoryItem.title, this.props.rootStore.audioStore, "Test", this.sizes.height * 0.1)}
                </Col>
            );
        }
    }
}
